export enum DocumentSourceType {
    PSR = 1,
    EMR = 2,
    FIELDTECH = 3,
    THIRDPARTY = 4,
    MRRUpload = 5,
    PEND = 9,
  }
